var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("editor", _vm._g(_vm._b({
    ref: "editor",
    staticClass: "custom-ck-editor-style",
    attrs: {
      defaultVal: _vm.defaultVal,
      disabled: _vm.disabled,
      "custom-upload": _vm.MyUploadAdapter
    }
  }, "editor", _vm.$attrs, false), _vm.$listeners))], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };